import React, { useState, useEffect, useRef } from "react";
import { Col, FormControl, FormSelect, Row, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
// import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import axios from "axios";
import PubSub from "pubsub-js";
// import WhiteObjectApi from "../../api/WhiteObjectApi";
// import SpinnerOverlay from "./SpinnerOverlay";
import { validationMessages } from "../../utils/messages";
import Select from "react-select";
import { getFormattedTimestamp } from "../../utils/helper";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
// import moment from "moment-timezone";

// Define initial errors i.e. required field and their message
const initialErrors = {
  // owner_id: { message: validationMessages.ownerId.required },
  remark: { message: validationMessages.remarks.required },
  folder_name: { message: validationMessages.folderName.required },
  file: { message: validationMessages.file.required },
};



const UserSiteVisitModal = (props) => {
  // console.log('props',props);
  const googleMapAddress = useRef(null);

  const { show, onHide, submitSiteVisit: submit } = props;

  // sate for visit data
  const [visitData, setVisitData] = useState(
    props.visitData ? props.visitData : null
  );
  // useEffect(()=>{console.log('visitData',visitData)},[visitData]);
  //errors state
  const [errors, setErrors] = useState(!props.visitData ? initialErrors : {});
  // useEffect(() => { console.log('errors', errors) }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);

  const [loading, setLoading] = useState(false);

  // assign users state
  // const [assignUsers, setAssignUsers] = useState([]);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [address, setAddress] = useState(props.visitData?.location);

  //Added By Farhan Khan On 13-Feb-2025 For States Manage for Files.
  const [files, setFiles] = useState([]);
  const [folderName, setFolderName] = useState("");
  //End Here.

  useEffect(() => {
    console.log("Site Visit", visitData);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(e.target);

    if (name == "remarks") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.remarks.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "folder_name") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.folderName.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    setValidated(true);
    setVisitData((prev) => ({ ...prev, [name]: value }));
  };

  const checkRequiredFields = () => {
    let isError = false;

    if (visitData?.remarks) {
      if (visitData?.remarks == "") {
        setErrors((prev) => ({
          ...prev,
          remarks: { message: validationMessages.remarks.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["remarks"];
          return { ...prev };
        });
      }
    }

   
      if (!folderName) {
        setErrors((prev) => ({
          ...prev,
          folder_name: { message: validationMessages.folderName.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["folder_name"];
          return { ...prev };
        });
      }

       if (!files?.length) {
        setErrors((prev) => ({
          ...prev,
          file: { message: validationMessages.file.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["file"];
          return { ...prev };
        });
      }

    // handle errors for required fields
    if (!visitData?.remarks) {
      setErrors((prev) => ({
        ...prev,
        remarks: { message: validationMessages.remarks.required },
      }));
      isError = true;
    }
    if (!folderName) {
      setErrors((prev) => ({
        ...prev,
        folder_name: { message: validationMessages.folderName.required },
      }));
      isError = true;
    }
    if (!files?.length) {
      setErrors((prev) => ({
        ...prev,
        file: { message: validationMessages.file.required },
      }));
      isError = true;
    }
    return isError;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("visitData", visitData);
    console.log("errors", errors);
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    if (visitData.action == "check-in") {
      visitData.logindatetime = getFormattedTimestamp();
      visitData.loginlattitude = latitude;
      visitData.loginlongitude = longitude;
    } else if (visitData.action == "check-out") {
      visitData.logoutdatetime = getFormattedTimestamp();
      visitData.logoutlattitude = latitude;
      visitData.logoutlongitude = longitude;
      visitData.visit_status = "Complete";
    }

    delete visitData.owner_name;
    delete visitData.lead_name;
    delete visitData.action;
    delete visitData.owner_ids;

    let formData = new FormData();

    setLoading(true);  
    // Append files
    for (let i = 0; i < files.length; i++) {
      formData.append(`files${i}`, files[i]);
    }

    // Append other form data
    // formData.append("description", fileDescription);
    formData.append("folder_name", folderName);

    // user Only update the site visit data
    let result = {};
    if (visitData?.id) {
      console.log("Visit File Upload", visitData.parentid);
      const resultFiles = await fuziElevatorsApi.createFile(
        visitData.parentid,
        formData
      );
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      if (resultFiles) {
        result = await fuziElevatorsApi.saveUserTracking(visitData);
        if (result?.success) {
          PubSub.publish("RECORD_SAVED_TOAST", {
            title: "Record Saved",
            message: "Record saved successfully",
          });
          // navigate(`/users/${visitData?.id}`, { state: visitData });
          submit();
        }
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record update Error",
          message: result?.errors,
        });
      }
    }
  };

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitude, longitude]);

  useEffect(() => {
    const Geocoder = window?.google?.maps?.Geocoder || null;
    Geocoder &&
      new Geocoder()?.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            googleMapAddress.current,
            mapProp
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
  }, [address]);

  const myMapFunction = async () => {
    if (!latitude || !longitude) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            googleMapAddress.current,
            mapProp
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitude, longitude);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(googleMapAddress.current, mapProp);

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: address,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: address,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  //File Upload Folder Handler Event (Added By Farhan Khan on 10-Feb-2025).
  const handleFolderChange = (event) => {
    const selectedFolder = event.target.value;
    const { name, value } = event.target
    if (name == "folder_name") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.folderName.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    setFolderName(selectedFolder);
  };

  //File Upload Handler To store File Detais.
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    const {name,files,value} = event.target;
    console.log('files',files);
    if (name == "file") {
      if (files?.length > 0 ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.file.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    setFiles(selectedFiles);
  };

  useEffect(() => {
    setAddress(visitData.location);
  }, [visitData.location])

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form
        className="mt-3"
        onSubmit={handleSubmit}
        noValidate
        validated={validated}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Site Visit {visitData?.lead_name || ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col md={12}>
              <div
                ref={googleMapAddress}
                className=""
                style={{ width: "100%", height: "200px", border: "none" }}
              ></div>
            </Col>
            <Col md={12}>
              <Row>
                <Col lg={6} className="mt-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicRemarks"
                    >
                      Remarks
                    </Form.Label>
                    <FormControl
                      required
                      name="remarks"
                      onChange={handleChange}
                      value={visitData?.remarks || ""}
                    />

                    {errors?.remarks?.message && !visitData.remarks && (
                      <div className="feedback-invalid">
                        {errors?.remarks?.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={6} className="mt-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicSiteLocation"
                    >
                      Site Location
                    </Form.Label>
                    <FormControl
                      name="location"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={visitData?.location || ""}
                    />
                  </Form.Group>
                </Col>

                <>
                  <Col lg={6} className="mt-2">
                    <Form.Group>
                      <Form.Label className="form-view-label">
                        Folder Name
                      </Form.Label>
                      <Form.Select
                        aria-label="Select Folder"
                        name="folder_name"
                        onChange={handleFolderChange}
                        required
                        value={folderName}
                        disabled={props.table === "Product"}
                      >
                        <option value="">--Select Folder--</option>
                        <option value="SiteMeasurement">Site Measurement</option>
                        <option value="SiteLocation">Site Location</option>
                        <option value="SiteVisitBuilding">
                          Site Visit Building
                        </option>
                        <option value="GAD">GAD</option>
                        <option value="Handover">Handover</option>
                        <option value="ProductImages">Products Images</option>
                        <option value="AMC">AMC</option>
                        {/* <option value="Check-In-Documents">
                     Check-In-Documents
                   </option> */}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors?.folder_name?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} className="mt-2">
                    <Form.Group controlId="formFile" className="mb-3">
                      <Form.Label>Select Files</Form.Label>
                      <Form.Control
                        required
                        type="file"
                        multiple
                        onChange={handleFileChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.file?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>


                  {loading && (
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  )}
                </>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="submit">
            <Button variant="success" disabled={loading} type="submit">
              Submit
            </Button>
          </div>
          <Button onClick={props.onHide} variant="light">
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserSiteVisitModal;
